// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d807e23a","732":"ea38b543"}[chunkId] + ".chunk.js";
};